import {
  Component,
  ChangeDetectorRef,
  OnChanges,
  OnInit,
  Input,
  ViewChild,
  QueryList,
  ViewChildren,
  Output,
  EventEmitter, OnDestroy
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormArray, FormControl, AbstractControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';

import { getAvailableLanguages } from 'utils/utils';
import { TableComponent } from 'shared/table/table/table.component';
import { createFormControl } from 'utils/form-control';
import { MarketingCopyService } from 'shared/marketing-copy/marketing-copy.service';
import {ProductPanelComponent} from '../../../../product-panel/product-panel.component';
import { rowData, contentData, collapseWidthPx } from './table-data';
import {DomSanitizer} from '@angular/platform-browser';
import {CollapseGroupComponent} from 'shared/collapse/collapse-group/collapse-group.component';
import {ScorecardConnectorService} from 'shared/scorecard/scorecard-connector.service';
import {DefaultModalComponent} from 'shared/modal/default-modal/default-modal.component';
import {UploadAssetsComponent} from 'shared/digital-assets/upload-assets/upload-assets/upload-assets.component';
import {
  AddAssetsModalComponent
} from '../../../../product-details-v2/components/digital-assets/add-assets-modal/add-assets-modal.component';
import * as utils from 'utils/utils';
import {LoaderComponent} from 'shared/loader/loader.component';
import {DigitalAssetsService} from 'shared/digital-assets/digital-assets.service';
import {AddUrlModalComponent} from 'shared/add-url-modal/add-url-modal.component';
import {GlobalValidationService} from 'shared/global-validation/global-validation.service';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { TableEditableComponent } from 'shared/table/table-editable/table-editable.component';
import objectHash from 'object-hash';
import { Location } from '@angular/common';


@Component({
  moduleId: module.id,
  selector: 'marketing-form',
  templateUrl: 'marketing-form.component.html',
  styleUrls: ['marketing-form.component.scss'],
})

export class MarketingFormComponent extends TableComponent implements OnChanges, OnInit, OnDestroy {
  headers: any[] = ['name', 'code', 'reference', 'value'];
  declare validators: any;
  form: UntypedFormGroup;

  @Input() lookups: any = {};
  @Input() brandId: string;
  @Input() segmentData: Array<any> = [];
  @Input() savingEvents: Observable<void>;

  editMode: boolean = false;
  rowData: any[] = rowData;
  contentData: any[] = contentData;

  segmentName: string = 'marketing';
  collapseWidth = collapseWidthPx;
  controlClassPrefix: string = 'marketing-control-row-';
  activeItem: UntypedFormGroup = null;
  editAssetData: any;
  editAssetIndex: number;
  expandedElementsIndexes: Array<number> = [];

  @ViewChildren(CollapseGroupComponent) collapseGroups: QueryList<CollapseGroupComponent>;
  @ViewChild('assetAddingModal') private assetAddingModal: DefaultModalComponent;
  @ViewChild(UploadAssetsComponent, {static: false}) uploadAssets: UploadAssetsComponent;
  @ViewChild(AddAssetsModalComponent, {static: false})
  addAssetsModal: AddAssetsModalComponent;
  @ViewChild(AddUrlModalComponent, {static: false})
  addUrlModal: AddUrlModalComponent;
  @ViewChild(LoaderComponent, {static: true})
  loader: LoaderComponent;

  @ViewChild(TableEditableComponent, {static: false}) tableEditable: TableEditableComponent | void;
  @Output() cancel: EventEmitter<any> = new EventEmitter();
  @Output() saveChanges: EventEmitter<any> = new EventEmitter();

  private savingEventsSubscription: Subscription;

  // public
  get marketingFormData(): UntypedFormArray {
    return this.form.get('marketingFormData') as UntypedFormArray;
  }

  get isInValid(): boolean {
    return this.form.invalid;
  }

  constructor(
    private fb: UntypedFormBuilder,
    private marketingCopyService: MarketingCopyService,
    private ref: ChangeDetectorRef,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
    protected sanitizer: DomSanitizer,
    protected scorecardConnectorService: ScorecardConnectorService,
    protected digitalAssetsService: DigitalAssetsService,
    protected globalValidationService: GlobalValidationService,
  ) {
    super();
    this.createForm();
  }

  ngOnInit() {
    this.savingEventsSubscription = this.savingEvents.subscribe(() => {
      this.editMode = false;
      if (this.route.snapshot.queryParams?.isFromProduct) {
        this.location.back();
      }
    });
  }

  ngOnChanges(changes: any) {
    this.setValidators();
    this.setFormData();
  }

  ngOnDestroy() {
    this.savingEventsSubscription.unsubscribe();
  }

  createForm(): void {
    this.form = this.fb.group({
      marketingFormData: this.fb.array([]),
    });
  }

  setFormData(): void {
    if (!this.data) { return; }
    const marketingFGs = this.data.map((item: any) => {
      const itemEl = this.createFormItem(item);
      return this.fb.group(itemEl);
    });
    const formArray = this.fb.array(marketingFGs);
    this.form.setControl('marketingFormData', formArray);
    const ids: string[] | string = this.route.snapshot.queryParams?.ids;
    if (!ids) { return; }
    const expandedHash: string[] = typeof ids === 'string' ? [ids] : ids;
    this.expandedElementsIndexes = this.data.map((row, index) => {
      const obj = {
        name: row.name,
        reference: row.reference,
        code: row.code,
        type: row.type
      };
      const rowHash = objectHash.MD5(JSON.stringify(obj));
      return expandedHash.includes(rowHash) ? index : -1;
    }).filter((i) => i !== -1);
    const isFromProduct: boolean = this.route.snapshot.queryParams?.isFromProduct;
    if (isFromProduct) {
      this.editMode = true;
    }
  }

  getCurrentCopies(item: any): any {
    const langData: any = this.getItemCurrLangData(item);
    return langData ? langData.copies : [];
  }

  getCurrentCopiesLength(item: any): any {
    const langData: any = _.find(item.data, {language_code: item.selectedLanguage});
    const copies = langData ? langData.copies : [];
    return copies ? copies.length : 0;
  }

  getReferenceLabel(item: any): string {
    const itemLookup = this.lookups[item['code']];
    const value = item.reference;
    const selectedLookup = _.find(itemLookup, (_item: any) => String(_item.option) === String(value));
    return selectedLookup ? selectedLookup.title : value;
  }

  getIsInvalidRow(row: UntypedFormGroup): boolean {
    const status = row.status;
    if (status === 'INVALID') {
      return true;
    }
    const rowId = row.value.id;
    const breakDownErrors = _.get(this.globalValidationService.validations, 'market-copy.break-down', null);
    if (!!breakDownErrors) {
      return !!breakDownErrors[rowId];
    }
    const assetsErrors = _.get(this.globalValidationService.validations, 'market-copy.assets', null);
    if (!assetsErrors) {
      return false;
    }
    return !!assetsErrors[rowId];
  }

  getIsAssetInvalid(asset: UntypedFormGroup, row: UntypedFormGroup): boolean {
    const assetsErrors = _.get(this.globalValidationService.validations, 'market-copy.assets', null);
    if (!assetsErrors) {
      return false;
    }
    const rowId = row.value.id;
    const rowErrors = assetsErrors[rowId];
    if (!rowErrors) {
      return false;
    }
    const rowErrorFileNames = rowErrors.map(item => item.filename);
    return rowErrorFileNames.indexOf(asset.value.filename) !== -1;
  }

  public fieldValidation(item: any, formGroup: UntypedFormGroup): any {
    if (!item) {
      return;
    }
    let validation = super.fieldValidation(item, formGroup);
    // PIES 6.7 validation row was added for test
    const pies65: any = _.find(validation, {name: 'PIES_6_5'});
    if (pies65) {
      validation = [...validation, {
        key: 'pies67',
        title: 'PIES 6.7',
        valid: pies65.valid,
      }];
    }
    return validation;
  }

  // handlers
  onLanguageChange(event: any, item: UntypedFormGroup) {
    const selectedLanguage = event.code;
    item.patchValue({selectedLanguage});
    const langItem = this.getFormItemCurrLangData(item);
    const copies = this.getCurrentCopies(item.value);
    const valuesCount = copies ? copies.length : 0;
    item.patchValue({valuesCount});
    // create 'copy' control for selectedLanguage if its not exists
    if (!langItem) {
      const data = this.createDataItem({copies: [''], language_code: selectedLanguage});
      (<UntypedFormArray>item.controls.data).push(this.fb.group(data));
    }
  }

  onRemoveCopyClick(item: UntypedFormGroup, index: number) {
    const langItem = this.getFormItemCurrLangData(item);
    if (langItem) {
      const copiesArray = langItem.get('copies') as UntypedFormArray;
      copiesArray.removeAt(index);
      this.form.markAsDirty();
    }
  }

  onCodeChange(codeOption: any, item: UntypedFormGroup) {
    item.get('reference').reset();
  }

  onAddAnotherCopyClick(item: UntypedFormGroup) {
    this.addAnotherCopy(item);
    this.form.markAsDirty();
  }

  onAddNewRowClick() {
    const newGroup = this.fb.group(this.createFormItem());
    this.addAnotherCopy(newGroup);
    this.marketingFormData.push(newGroup);
    this.form.markAsDirty();
  }

  getRefLowerCase(ref: string): string {
    return _.lowerCase(ref);
  }

  // private
  private createFormItem(obj: any = {
    _id: '',
    origin_id: '',
    name: '',
    brand_relationship_id: '',
    reference: '',
    type: '',
    code: '',
    code_lookup: [],
    sub_code : '',
    sub_code_reference: '',
    language_code: 'EN',
    selectedLanguage: 'EN',
    value: '',
    languages: getAvailableLanguages(),
    data: [{
      copies: [],
      language_code: 'EN',
    }],
  }): any {
    const res = {
      id: createFormControl('_id', obj._id),
      originId: createFormControl('origin_id', obj.origin_id),
      name: createFormControl('name', obj.name, this.validators),
      brandRelationshipId: createFormControl('brand_relationship_id', obj.brand_relationship_id),
      reference: createFormControl('reference', obj.reference),
      type: createFormControl('type', obj.type),
      code: createFormControl('code', obj.code),
      codeLookup: createFormControl('code_lookup', obj.code_lookup),
      subCode: createFormControl('sub_code', obj.sub_code),
      subCodeReference: createFormControl('sub_code_reference', obj.sub_code_reference),
      languageCode: createFormControl('language_code', obj.language_code),
      selectedLanguage: createFormControl('selectedLanguage', obj.selectedLanguage),
      value: createFormControl('value', obj.value),
      languages: this.createFormItemLanguages(obj.languages),
      data: this.createFormItemData(obj.data),
      digitalAssets: this.createFormItemAssets(obj.digitalAssets),
      valuesCount: createFormControl('valuesCount', this.getCurrentCopiesLength(obj)),
    };
    return res;
  }

  private createFormItemLanguages(languages: any[]): UntypedFormArray {
    const res = this.fb.array([]);
    _.forEach(languages, (item: any) => {
      const group = this.fb.group({
        title: createFormControl('title', item.title),
        active: createFormControl('active', item.active),
        code: createFormControl('code', item.code),
      });
      res.push(group);
    });
    return res;
  }

  private createFormItemData(data: any[]): UntypedFormArray {
    const res = this.fb.array([]);
    _.forEach(data, (item: any) => {
      const dataItem = this.createDataItem(item);
      const group = this.fb.group({...dataItem});
      res.push(group);
    });
    return res;
  }

  private createFormItemAssets(assets: any[]): UntypedFormArray {
    const res = this.fb.array([]);
    _.forEach(assets, (item: any) => {
      const group = this.fb.group({
        asset: createFormControl('asset', item),
      });
      res.push(group);
    });
    return res;
  }

  private createDataItem(obj: any = {
    copies: [],
    language_code: '',
    }): any {
    const res = {
      copies: this.fb.array([]),
      languageCode: createFormControl('languageCode', obj.language_code),
    };
    _.forEach(obj.copies, copy => {
      this.addCopy(res, copy);
    });
    return res;
  }

  private createCopy(text: string, origin_id: string) {
    return this.fb.group({
      value: createFormControl('value', text, this.validators),
      origin_id: createFormControl('origin_id', origin_id),
    });
  }

  private addCopy(item: any, copy: any): void {
    const copyGroup = this.createCopy(copy.value, copy.origin_id);
    item.copies.push(copyGroup);
  }

  private addAnotherCopy(item: UntypedFormGroup): void {
    const langItem = this.getFormItemCurrLangData(item);
    const copyGroup = this.createCopy('', null);
    const copiesArray = langItem.get('copies') as UntypedFormArray;
    copiesArray.push(copyGroup);
  }

  private getItemCurrLangData(item: any): any {
    return _.find(item.data, {languageCode: item.selectedLanguage});
  }

  private getFormGroupLangData(data: UntypedFormArray, languageCode: string): UntypedFormGroup {
    return _.find(data.controls, (item: UntypedFormGroup) => {
      return item.get('languageCode').value === languageCode;
    }) as UntypedFormGroup;
  }

  private getFormItemCurrLangData(item: UntypedFormGroup): any {
    const selectedLanguage = item.value.selectedLanguage;
    const data = item.get('data') as UntypedFormArray;
    let res = null;
    _.forEach(data.controls, (_item: any) => {
      if (_item.value.languageCode === selectedLanguage) {
        res = _item;
        return;
      }
    });
    return res;
  }

  private getLangCopyControl(data: UntypedFormArray, index: number, language: string): AbstractControl|undefined {
    const dataFormGroup: UntypedFormGroup = this.getFormGroupLangData(data, language);
    const copies = dataFormGroup.get('copies') as UntypedFormArray;
    return copies.at(index);
  }

  private showLanguageBadge(item: UntypedFormGroup, index: number, language: string): boolean {
    const control: any = this.getLangCopyControl(item.get('data') as UntypedFormArray, index, language);
    if (control) {
      // show badge if control value is not empty
      if (control.value) { return true; }
        // show badge if selected language === badge language
      if (!control.value && item.value.selectedLanguage === language) { return true; }
    }
    return false;
  }


  onRowAdd() {
    const newGroup = this.fb.group(this.createFormItem());
    this.addAnotherCopy(newGroup);
    const oldGroup = (this.form.get('marketingFormData') as UntypedFormArray).controls;
    this.form.setControl('marketingFormData', this.fb.array([...oldGroup, newGroup]));
    this.form.markAsDirty();
    this.ref.markForCheck();
    _.defer(() => {
      this.collapseRow((this.form.get('marketingFormData') as UntypedFormArray).controls.length - 1, false);
    });
  }

  get formArray(): UntypedFormArray {
    return this.marketingFormData;
  }
  protected getTitle(name: string): string {
    // find title in rowData
    // @ts-ignore
    const colData = _.find(this.rowData, {fieldName: name});
    if (_.get(colData, 'title')) { return colData.title; }

    // find title in segmentData
    // @ts-ignore
    const item = _.find(this.segmentData, {field_map: name});
    return item ? item.title : '';
  }

  protected getInvalidDot(fieldMap: string, formGroup: UntypedFormGroup, index: number) {
    const control = _.get(formGroup, `controls.${fieldMap}`);
    if (control.invalid) {
      return   this.sanitizer.bypassSecurityTrustHtml(`
        <div class="circle-icon size-small cell-invalid-dot circle-red"
        data-ghost="cell-invalid-dot-${fieldMap}-${index}"></div>
      `);
    } else {
      return null;
    }
  }

  isCollapse(index: number) {
    return this.expandedElementsIndexes.indexOf(index) === -1;
  }

  onCollapseClick(index: number) {
    this.collapseRow(index);
  }

  protected collapseRow(index: number, collapse?: boolean) {
    // pass -1 to collapse all
    const collapseGroupsArr: any = this.collapseGroups.toArray();

    if (!_.get(collapseGroupsArr, 'length') || !_.get(collapseGroupsArr, `[${index}]`)) { return; }
    if (_.isNil(collapse)) { collapse = !collapseGroupsArr[index].collapsed; }
    collapseGroupsArr[index].setCollapsed(collapse);
    this.expandedElementsIndexes = collapseGroupsArr.map((item, i) => item.collapsed === false ? i : -1).filter(item => item !== -1);

    // this.scorecardConnectorService.tableRowCollapsed.emit({
    //   index,
    //   collapsed: collapse,
    // });

    this.ref.markForCheck();
  }

  public getFieldLookup(fieldMap: string, codeValue?: string): any[] {
    const field: any = this.getField(fieldMap);
    if (field.field_map === 'reference' && !!codeValue) {
      _.set(field, 'lookup', this.lookups[codeValue]);
    }
    return field ? field.lookup : null;
  }

  public getField(fieldMap: string): string {
    // @ts-ignore
    return _.find(this.segmentData, {field_map: fieldMap});
  }

  get isEditMode(): boolean {
    return this.editMode;
  }

  set isEditMode(value: boolean) {
    this.editMode = value;
  }

  toggleEditMode() {
    this.editMode = !this.editMode;
  }

  get isFormChanged(): boolean {
    if (this.isEditMode) {
      return !!this.form.dirty;
    } else {
      return false;
    }
  }

  onViewEditSaveClick() {
    if (this.isFormChanged) {
      this.saveChanges.emit();
    } else {
      if (this.route.snapshot.queryParams?.isFromProduct) {
        this.location.back();
      }
      this.toggleEditMode();
    }
  }

  onCancelClick() {
    if (this.route.snapshot.queryParams?.isFromProduct) {
      this.location.back();
    }
    this.cancel.emit();
  }

  onAssetClick(event: any, item: UntypedFormGroup) {
    this.activeItem = item;
    this.assetAddingModal.show();
  }

  onAssetEditClick(asset: any, item: UntypedFormGroup, index?: number) {
    if (!this.editMode) {
      return;
    }
    this.activeItem = item;
    this.editAssetData = asset;
    this.editAssetIndex = index;
    this.addUrlModal.show();
  }
  onModalCloseClick() {
    this.assetAddingModal.hide();
  }

  get hasEditPermission(): boolean {
    return true;
  }

  onUploadAssetClick() {
    this.uploadAssets.showUploadModal();
  }

  onAddAssetClick() {
    this.addAssetsModal.show();
  }

  onAddUrlClick() {
    this.editAssetData = null;
    this.addUrlModal.show();
    // const emptyAsset: any = createEmptyPAGAsset();
    // this.itemDetailData.push(emptyAsset);
    // this.digitalAssets.push(this.createFormGroup(this.segmentData, emptyAsset));
    // this.scorecardConnectorService.controlAdded.emit({assets: this.itemDetailData, controls: this.digitalAssets});
    // this.markAsDirty();
    // this.ref.markForCheck();
  }

  get itemDetailData(): Array<any> {
    return [];
  }

  get isEmpty(): boolean {
    return !_.get(this.marketingFormData, 'controls.length');
  }

  onAssetsAdd(assets: Array<any>) {
    _.each((_.get(this.activeItem, 'controls.digitalAssets') as UntypedFormArray).controls, (group: UntypedFormGroup) => {
      const id = _.get(group.get('_id'), 'value');
      const asset = _.find(assets, ['_id', id]);

      if (asset && id) {
        const assetType = _.get(group.get('assetType'), 'value');
        const representation = _.get(group.get('representation'), 'value');
        _.set(asset, 'asset_type', assetType);
        _.set(asset, 'representation', representation);
      }
    });
    assets.map((asset) => (_.get(this.activeItem, 'controls.digitalAssets') as UntypedFormArray).push(this.fb.group({
      asset: createFormControl('asset', asset)
    })));
    this.formArray.markAsDirty();
    this.assetAddingModal.hide();
  }

  onAssetsSaved(assets: Array<any>) {
    _.each((_.get(this.activeItem, 'controls.digitalAssets') as UntypedFormArray).controls, (group: UntypedFormGroup) => {
      const id = _.get(group.get('_id'), 'value');
      const asset = _.find(assets, ['_id', id]);

      if (asset && id) {
        const assetType = _.get(group.get('assetType'), 'value');
        const representation = _.get(group.get('representation'), 'value');
        _.set(asset, 'asset_type', assetType);
        _.set(asset, 'representation', representation);
      }
    });
    assets.map((asset) => (_.get(this.activeItem, 'controls.digitalAssets') as UntypedFormArray).push(this.fb.group({
      asset: createFormControl('asset', asset)
    })));
    this.formArray.markAsDirty();
    this.assetAddingModal.hide();
  }

  onUrlAdd(asset) {
    if (this.editAssetData) {
      this.editAssetData.patchValue(asset);
      this.formArray.markAsDirty();
      return;
    }

    (_.get(this.activeItem, 'controls.digitalAssets') as UntypedFormArray).push(this.fb.group({
      asset: createFormControl('asset', asset),
    }));
    this.formArray.markAsDirty();
    this.assetAddingModal.hide();
  }

  onRemoveAsset(asset) {
    const formArray = (_.get(this.activeItem, 'controls.digitalAssets') as UntypedFormArray);
    formArray.removeAt(this.editAssetIndex);
    this.formArray.markAsDirty();
  }

  public getFieldTitle(name: string): string {
    return name === 'value' ? 'Copy' : utils.getFieldTitle(name, this.segmentData);
  }

  onRowRemove(formGroup: UntypedFormGroup) {
    const index = this.formArray.controls.indexOf(formGroup);
    this.formArray.removeAt(index);
    this.data.splice(index, 1);
    this.formArray.markAsDirty();
  }
}
